// extracted by mini-css-extract-plugin
module.exports = {"innerContainer":"signUpPage_innerContainer__hL429","title":"signUpPage_title__1gNoO","signInForm":"signUpPage_signInForm__1t5Dn"};